// sync-start:program-embed-domains 1798528077 apps/classroom/src/embedded-content-routes.ts
export const PROGRAM_DOMAINS = [
    "pixar",
    "nasa",
    "piab-sandbox",
    "computer-science",
    "computer-programming",
    "hour-of-code",
    "math",
    "differential-equations",
    "electrical-engineering",
    "mcat",
    "apchem-topic",
    "chemistry",
    "art-history-basics",
    "biology",
];
// sync-end:program-embed-domains

export const PROGRAM_DOMAINS_MATCHING_GROUP = `(${PROGRAM_DOMAINS.join("|")})`;
